import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import BottomBar from '../BottomBar';
import CoffeeChat from '../../../../images/onboarding/practitioner/coffeechat.svg';
import { scrollToTop } from '../scroll';

function Introduction(props) {
  useEffect(() => {
    scrollToTop();
  }, []);

  const email = props.intl.formatMessage({
    defaultMessage: 'collaboration@greenshield.ca',
  });
  return (
    <div>
      <CoffeeChat className="coffee-chat" style={{ marginBottom: '40px' }} />
      <h1 style={{ marginBottom: '40px' }}>
        <FormattedMessage defaultMessage="Welcome to the GreenShield Health Practitioner Portal!" />
      </h1>
      <p>
        <FormattedMessage defaultMessage="The next step is to complete your practitioner profile and account by adding your personal, professional, and practice details. Once that is complete, a member of the practitioner network team will be in touch to verify the information you have provided." />
      </p>
      <p>
        <FormattedMessage
          defaultMessage="If you have any questions, please contact {link}."
          values={{
            link: <a href={`mailto:${email}`}>{email}</a>,
          }}
        />
      </p>
      <BottomBar {...props} />
    </div>
  );
}

Introduction.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default injectIntl(Introduction);
